import {
  InlineAlertType,
  Maybe,
  SdInlineAlert,
} from '@varo/graphql-schema-types';
import { iconKeyForStyleDictionary } from 'shared/components/vxl/icon/Icon/Icon.helpers';
import { InlineAlertProps } from 'shared/components/vxl/InlineAlert/InlineAlert';
import { VXLComponentId, VXLNode } from 'shared/renderer/types';

export default function sdInlineAlert(alert: SdInlineAlert): Maybe<VXLNode> {
  const iconKeyType = alert.icon ? iconKeyForStyleDictionary(alert.icon) : null;

  return {
    id: 'alert',
    name: VXLComponentId.INLINE_ALERT,
    props: {
      iconKeyType,
      bodyText: alert.title?.copy || '',
      alertType: InlineAlertType.Info,
    } satisfies InlineAlertProps,
  };
}
